import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

import { GinoMainSectionIcon } from "../../assets/icons/gino-icons";

const GinoOpeningMessage = ({
  askingAbout,
}: {
  askingAbout: "player" | "professional" | "trainingPlan" | "nutritionPlan" | "trialPrepTryout";
}) => {
  const { t } = useTranslation("gino", { keyPrefix: "component.openingMessage" });

  return (
    <Box sx={styles.openingMessage}>
      <GinoMainSectionIcon />
      <Box sx={styles.openingMessageTextContainer}>
        <Typography sx={styles.openingMessageTitle}>
          {askingAbout === "player" && t("scoutYourNextStarPlayer")}
          {askingAbout === "professional" && t("hireAProfessional")}
          {askingAbout === "trainingPlan" && t("trainingPlan")}
          {askingAbout === "nutritionPlan" && t("nutritionPlan")}
          {askingAbout === "trialPrepTryout" && t("trialPrepTryout")}
        </Typography>
        <Typography sx={styles.openingMessageSubTitle}>
          {askingAbout === "player" && t("describeTheIdealPlayerYouAreLookingFor")}
          {askingAbout === "professional" && t("describeTheProfessionalYouAreLookingFor")}
          {askingAbout === "trainingPlan" && t("describeTheTrainingPlanYouAreLookingFor")}
          {askingAbout === "nutritionPlan" && t("describeTheNutritionPlanYouAreLookingFor")}
          {askingAbout === "trialPrepTryout" && t("describeTheTrialPrepTryoutYouAreLookingFor")}
        </Typography>
        <Typography sx={styles.openingMessageExample}>
          {askingAbout === "player" && t("playerExample")}
          {askingAbout === "professional" && t("professionalExample")}
          {askingAbout === "trainingPlan" && t("trainingPlanExample")}
          {askingAbout === "nutritionPlan" && t("nutritionPlanExample")}
          {askingAbout === "trialPrepTryout" && t("trialPrepTryoutExample")}
        </Typography>
      </Box>
    </Box>
  );
};

export default GinoOpeningMessage;

const styles = {
  openingMessage: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  openingMessageTextContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },
  openingMessageTitle: {
    color: "var(--text-base-primary, #14151A)",
    fontFamily: "Montserrat",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "150%",
  },
  openingMessageSubTitle: {
    color: "var(--Color-Gray-400, #9CA3AF)",
    fontFamily: "Montserrat",
    fontSize: "var(--typography-size-h6, 24px)",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "var(--typography-line-height-h6, 32px)",
    letterSpacing: "var(--typography-letter-spacing-h6, -0.3px)",
    mb: "6px",
  },
  openingMessageExample: {
    color: "var(--text-base-secondary, rgba(15, 19, 36, 0.60))",
    fontFamily: "Montserrat",
    fontSize: "var(--typography-size-body-s, 16px)",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "var(--typography-line-height-body-s, 24px)",
    letterSpacing: "var(--typography-letter-spacing-body-s, -0.2px)",
  },
};
